import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Handle, Position } from 'react-flow-renderer';
import { DTMF_KEYS , ACTION_COLORS} from '../../../../../utilities/constant'
import { NodesContext } from '../provider/IvrContext';
import AudioPreviewModal from '../Helpers/AudioPreviewModel';
import { BACKEND_API_BASE_URL} from "../../../../../utilities/constant";
import { getApiCall } from '../../../../../service/httpCall';
import { toast } from 'react-toastify';


const DtmfNode = ({ data, id }) => {
    const { smsWebhookList, updateNodeData, onRemove } = useContext(NodesContext);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [smsModalIsOpen, setSmsModalIsOpen] = useState(false);
    const [audio, setAudio] = useState([]);
    const [noInputFileList, setNoInputFileList] = useState([]);
    const [wrongInputFileList, setWrongInputFileList] = useState([]);
    const [errors, setErrors] = useState({});
    const [tempSmsData, setTempSmsData] = useState({});
    const [smsErrors, setSmsErrors] = useState({});
    const [playModalOpen, setPlayModalOpen] = useState(false);
    // const [manualDigits, setManualDigit] = useState();
    const [audioPlay, setAudioPlay] = useState();
    const [audioType, setAudioType] = useState();

    const {
        action = {},
        type = "",
        numDigits = 1,
        timeout = "",
        numSources = [],
        rePrompt = "",
        ttsRows = [],
        minValue = "",
        selectedHandles = {},
        smsData = {},
    } = data;
    const menuAudioUrl = action?.menu?.audio || "";
    const menuAudioName = action?.menu?.name || "";

    const [draftData, setDraftData] = useState({
        action,
        type,
        numDigits,
        timeout,
        rePrompt,
        selectedHandles,
        // manualDigits: data.manualDigits || "",
    });


    const openModal = () => {
        setDraftData({
            action,
            type,
            numDigits,
            timeout,
            rePrompt,
            selectedHandles,
            // manualDigits: data.manualDigits || "",
        });

        setErrors({});
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setDraftData({
            action,
            type,
            numDigits,
            timeout,
            rePrompt,
            selectedHandles,
            // manualDigits: data.manualDigits || "",
        });

        setErrors({});
        setModalIsOpen(false);
    };

    const openSmsModal = () => {
        setTempSmsData(JSON.parse(JSON.stringify(smsData || {})));
        setSmsErrors({});
        setSmsModalIsOpen(true);
    };
    const closeSmsModal = () => {
        setTempSmsData({});
        setSmsErrors({});
        setSmsModalIsOpen(false);
    };
    useEffect(() => {
        const fetchPrompts = async () => {
            try {
                const resp = await getApiCall(`${BACKEND_API_BASE_URL}/v2/prompt?prompt_status=1&user_id=${data.userId}`)
                if (!Array.isArray(resp)) return;

                setAudio(resp.filter(item => item.prompt_category === 'Menu'));
                setNoInputFileList(resp.filter(item => item.prompt_category === 'No Input'));
                setWrongInputFileList(resp.filter(item => item.prompt_category === 'Wrong Input'));
            } catch (err) {
                console.error(err);
            }
        };

        fetchPrompts();
    }, [ data.userId]);

    const toggleSmsEnable = (key) => {
        setTempSmsData(prev => {
            const updated = { ...prev };
            updated[key] ? delete updated[key] : (updated[key] = {});
            return updated;
        });
    };

    const validateSmsData = () => {
        const errors = {};

        Object.keys(tempSmsData).forEach(key => {
            if (!tempSmsData[key]?.payload) {
                errors[key] = "Webhook is required";
            }
        });

        setSmsErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const updateSmsUrl = (key, e) => {
        const option = e.target.selectedOptions[0];

        setTempSmsData(prev => ({
            ...prev,
            [key]: {
                payload: option.value,
                id: option.dataset.id,
            },
        }));
    };

    const updateNode = (updates) =>
        updateNodeData(id, { ...data, ...updates });

    const saveSmsData = () => {
        if (!validateSmsData()) return;

        updateNode({ smsData: tempSmsData });
        toast.success("SMS Configuration Saved.")
        closeSmsModal();
    };

    const toggleHandle = (index) => {
        const handleId = `${id}_handle-${index}`;
        const updated = { ...draftData.selectedHandles };

        if (updated[handleId]) delete updated[handleId];
        else updated[handleId] = {
            type: "source",
            position: "bottom",
            left: index * 10 + 10,
        };

        setDraftData(prev => ({
            ...prev,
            selectedHandles: updated,
            numSources: Object.keys(updated).map(h => Number(h.split("-")[1]))
        }));
    };

    const updateActionAudio = (key, list, value) => {

        if (value === "") {
            setDraftData(prev => ({
                ...prev,
                action: {
                    ...prev.action,
                    [key]: null,
                }
            }));
            return;
        }

        const selected = list.find(i => i.id.toString() === value);
        if (!selected) return;

        setDraftData(prev => ({
            ...prev,
            action: {
                ...prev.action,
                [key]: {
                    id: selected.id,
                    audio: selected.prompt_url,
                    duration: selected?.prompt_duration ?? 0,
                    name: selected.prompt_name
                }
            }
        }));
    };


    const validateForm = () => {
        const newErrors = {};
        if (!draftData.action?.menu?.id) {
            newErrors.audio = 'Audio is required';
        }
        if (draftData.timeout === '' || draftData.timeout === null) newErrors.timeout = 'Wait time is required';

        const digitCount = Number(draftData.numDigits);

        // if (digitCount > 1) {
        //     if (!draftData.manualDigits) {
        //         newErrors.manualDigits = `Enter exactly ${digitCount} digits`;
        //     } else if (draftData.manualDigits.length !== digitCount) {
        //         newErrors.manualDigits = `Must be exactly ${digitCount} digits`;
        //     }
        // } else 
        if (digitCount == 1) {
           if (Object.keys(draftData.selectedHandles).length < 1) {
             newErrors.selectHandles = `Atleast Select One Handle`;
           }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = () => {
        if (!validateForm()) return;

        updateNode({
            ...draftData,
        });

        toast.success("Detail Added Successfully.");
        setModalIsOpen(false);
    };


    const renderedHandles = useMemo(() => Object.entries(draftData.selectedHandles).map(([handleId, handle]) => (
        <Handle key={handleId} type={handle.type} position={handle.position} id={handleId} style={{ left: `${handle.left}px`, backgroundColor: 'purple', width: 8, height: 8 }} />
    )), [draftData.selectedHandles]);
    const renderSingle = useMemo(() => (
        <Handle
            id={`${id}_single_source`}
            type="source"
            position={Position.Bottom}
            isConnectable={Number(numDigits) !== 1}
            style={{
                backgroundColor: 'purple',
                width: 8,
                height: 8,
                opacity: Number(numDigits) !== 1 ? 1 : 0,
                pointerEvents: Number(numDigits) !== 1 ? 'auto' : 'none',
            }}
        />
    ), [numDigits, id]);

    return (
        <div style={{
            width: Object.keys(draftData.selectedHandles).length === 0 ? 100 : Object.keys(draftData.selectedHandles).length + 120,
            height: 40,
            border: '2px solid purple',
            borderRadius: 12,
            background: '#fff',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
            transition: '0.3s ease-in-out'
        }}>
            <Handle type="target" position="top" id={id} style={{ left: '50%', transform: 'translateX(-50%)', backgroundColor: 'purple', width: 8, height: 8 }} />
            {renderedHandles}
            {renderSingle}
            <span style={{ fontSize: 11, fontWeight: 'bold', color: '#333', textAlign: 'center', textTransform: 'capitalize' }}>DTMF Node</span>

            <div style={{ display: 'flex', gap: 10 }}>
                <i className="fa fa-cog" style={{ color: 'purple', fontSize: 14, cursor: 'pointer' }} title="Settings" onClick={openModal} />
                <i className="fa fa-trash" style={{ color: 'purple', fontSize: 14, cursor: 'pointer' }} title="Remove" onClick={() => onRemove(id)} />
                {Boolean(Object.keys(draftData.selectedHandles).length) && <i className="fa fa-envelope" style={{ color: 'purple', fontSize: 14, cursor: 'pointer' }} title="Message" onClick={openSmsModal} />}
                {menuAudioUrl && (
                    <i
                        className="fa fa-play"
                        style={{ color: 'green', fontSize: 14, cursor: 'pointer' }}
                        title="Play Menu Audio"
                        onClick={() => setPlayModalOpen(true)}
                    />
                )}
            </div>

            <Modal show={modalIsOpen} onHide={closeModal} backdrop="static" style={{ zIndex: 1050 }} size="lg">
                <Modal.Header closeButton><Modal.Title>DTMF Node Settings</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Form>
                        <div style={{ display: 'flex', gap: 10 }}>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Type:</Form.Label>
                                <Form.Control as="select" name="type" value={draftData.type} 
                                onChange={e =>
                                    setDraftData(prev => ({ ...prev, type: e.target.value }))
                                }
                                >
                                    <option value="">Select Type</option>
                                    <option value="digits">Digits</option>
                                </Form.Control>
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Select Audio:{<Form.Text className="text-danger">*</Form.Text>}</Form.Label>
                                <Form.Control as="select" name="audioId" value={draftData.action.menu?.id || ""}
                                    onChange={e => updateActionAudio("menu", audio, e.target.value)}>
                                    <option value="">Select Audio</option>
                                    {audio.map(a => <option key={a.id} value={a.id}>{a.prompt_name}</option>)}
                                </Form.Control>
                                {errors.audio && <Form.Text className="text-danger">{errors.audio}</Form.Text>}
                            </Form.Group>
                        </div>

                        <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Num Digits:</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="numDigits"
                                    value={draftData.numDigits}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        setDraftData(prev => ({
                                            ...prev,
                                            numDigits: value
                                        }));
                                    }}

                                    onBlur={() => {
                                        let finalValue = Number(draftData.numDigits);

                                        if (!finalValue || finalValue < 1) {
                                            finalValue = 1;
                                        }

                                        setDraftData(prev => ({
                                            ...prev,
                                            numDigits: finalValue,
                                            selectedHandles: finalValue === 1 ? prev.selectedHandles : {}
                                        }));

                                        // if (finalValue === 1) {
                                        //     setManualDigit("");
                                        // }
                                    }}

                                />
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Wait Time (s):{<Form.Text className="text-danger">*</Form.Text>}</Form.Label>
                                <Form.Select name="timeout" value={draftData.timeout}
                                    onChange={e =>
                                        setDraftData(prev => ({ ...prev, timeout: e.target.value }))
                                    }
                                    >
                                    <option value="">Select Wait Time</option>
                                    {draftData.numDigits > 1
                                        ? [3,4,5].map(n => (
                                            <option key={n} value={n}>
                                                {n}
                                            </option>
                                            ))
                                        : Array.from({ length: 20 }, (_, i) => i + 1).map(n => (
                                            <option key={n} value={n}>
                                                {n}
                                            </option>
                                            ))
                                    }
                                </Form.Select>
                                {errors.timeout && <Form.Text className="text-danger">{errors.timeout}</Form.Text>}
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                                <Form.Label>Re-Prompt Count:</Form.Label>
                                <Form.Select
                                name="rePrompt"
                                value={draftData.rePrompt}
                                onChange={e =>
                                    setDraftData(prev => ({ ...prev, rePrompt: e.target.value }))
                                }
                                >
                                <option value="">Select Re-Prompt Count</option>
                                {[0, 1, 2, 3].map(n => (
                                    <option key={n} value={n}>
                                    {n}
                                    </option>
                                ))}
                                </Form.Select>
                            </Form.Group>
                        </div>

                        <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
                        <Form.Group style={{ flex: 1 }}>
                            <Form.Label>No Input File:</Form.Label>

                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <Form.Select
                                name="noInputFileId"
                                value={draftData.action?.noInputFileId?.id || ""}
                                onChange={e =>
                                updateActionAudio("noInputFileId", noInputFileList, e.target.value)
                                }
                            >
                                <option value="">Select No-Input File</option>
                                {noInputFileList.map(a => (
                                <option key={a.id} value={a.id}>
                                    {a.prompt_name}
                                </option>
                                ))}
                            </Form.Select>

                            {draftData.action?.noInputFileId?.audio && (
                                <i
                                className="fa fa-play"
                                style={{ color: "green", fontSize: 16, cursor: "pointer" }}
                                title="Play No Input Audio"
                                onClick={() => {
                                    setAudioPlay(draftData.action.noInputFileId.audio);
                                    setPlayModalOpen(true);
                                    setAudioType('No Input Audio Preview')
                                }}
                                />
                            )}
                            </div>
                        </Form.Group>

                        {/* Wrong Input */}
                        <Form.Group style={{ flex: 1 }}>
                            <Form.Label>Wrong Input File:</Form.Label>

                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <Form.Select
                                name="wrongInputFileId"
                                value={draftData.action?.wrongInputFileId?.id || ""}
                                onChange={e =>
                                updateActionAudio("wrongInputFileId", wrongInputFileList, e.target.value)
                                }
                            >
                                <option value="">Select Wrong-Input File</option>
                                {wrongInputFileList.map(a => (
                                <option key={a.id} value={a.id}>
                                    {a.prompt_name}
                                </option>
                                ))}
                            </Form.Select>

                            {draftData.action?.wrongInputFileId?.audio && (
                                <i
                                className="fa fa-play"
                                style={{ color: "green", fontSize: 16, cursor: "pointer" }}
                                title="Play Wrong Input Audio"
                                onClick={() => {
                                    setAudioPlay(draftData.action.wrongInputFileId.audio);
                                    setPlayModalOpen(true);
                                    setAudioType('Wrong Input Audio Preview')
                                }}
                                />
                            )}
                            </div>
                        </Form.Group>

                        </div>

                        <Form.Group style={{ marginTop: 10 }}>
                            {Number(draftData.numDigits) === 1 &&
                                <>
                                    <Form.Label>Digits (Select Values):{<Form.Text className="text-danger">*</Form.Text>}</Form.Label>
                                    {errors.selectHandles && (
                                        <Form.Text className="text-danger" style={{ marginLeft : '10px'}}>
                                            {errors.selectHandles}
                                        </Form.Text>
                                    )}
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
                                        {DTMF_KEYS.map((key, idx) => (
                                            <label key={idx}>
                                                <input type="checkbox" checked={draftData.selectedHandles[`${id}_handle-${idx}`] !== undefined} onChange={() => toggleHandle(idx)} style={{ marginRight: 5 }} />
                                                {key}
                                            </label>
                                        ))}
                                    </div>
                                </>
                                // : <>
                                // <Form.Control
                                //     type="number"
                                //     placeholder={`Enter exactly ${numDigits} digit${numDigits > 1 ? 's' : ''}`}
                                //     value={manualDigits || ''}
                                //     onChange={(e) => {
                                //         const value = e.target.value.replace(/\D/g, "").slice(0, numDigits);
                                //         setManualDigit(value);
                                //     }}
                                // /></>
                                }
                            {/* {errors.manualDigits && (
                                <Form.Text className="text-danger">
                                    {errors.manualDigits}
                                </Form.Text>
                            )} */}
                        </Form.Group>

                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleSave}>Add</Button>
                    <Button variant="secondary" onClick={closeModal}>Discard</Button>
                </Modal.Footer>
            </Modal>

            {/* SMS Modal */}
            <Modal
                size="lg"
                show={smsModalIsOpen}
                onHide={closeSmsModal}
                backdrop="static"
                style={{ zIndex: 1050 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>DTMF SMS Modal</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: "500px", overflowY: "auto" }}>
                    {Object.keys(draftData.selectedHandles).length === 0 ? (
                        <p>No DTMF key selected.</p>
                    ) : (
                        Object.keys(draftData.selectedHandles).map((handleKey) => {
                            const index = handleKey.split('-')[1];
                            const keyLabel = DTMF_KEYS[index];
                            const lable = `DTMF_${keyLabel}`
                            const checked = !!tempSmsData[lable];
                            return (
                                <Form.Group className="mb-3" key={handleKey}>
                                    <Form.Check
                                        type="checkbox"
                                        id={`dtmf-${index}`}
                                        label={`DTMF ${keyLabel}`}
                                        checked={checked}
                                        required
                                        onChange={() => toggleSmsEnable(lable)}
                                    />
                                    {checked && smsWebhookList && smsWebhookList.length > 0 && (
                                        <>
                                            <Form.Select
                                                className="mt-2"
                                                value={tempSmsData[lable]?.payload || ""}
                                                onChange={(e) => updateSmsUrl(lable, e)}
                                            >
                                                <option value="">Select SMS Webhook</option>
                                                {smsWebhookList.map((obj, idx) => {
                                                    const valueObj = {
                                                        url: obj.url,
                                                        smsText: obj.sms_text,
                                                        requestType: obj.request_type,
                                                        payload: obj.payload,
                                                        header: obj.header
                                                    };
                                                    return (
                                                        <option data-id={obj.id} value={JSON.stringify(valueObj)} key={idx}>
                                                            {obj.webhook_name}
                                                        </option>
                                                    );
                                                })}
                                            </Form.Select>
                                            {smsErrors[lable] && (
                                                <Form.Text className="text-danger">
                                                    {smsErrors[lable]}
                                                </Form.Text>
                                            )}
                                        </>
                                    )}
                                </Form.Group>
                            );
                        })
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={saveSmsData}>Save</Button>
                    <Button variant="secondary" onClick={closeSmsModal}>Discard</Button>
                </Modal.Footer>
            </Modal>

            <AudioPreviewModal
                show={playModalOpen}
                onClose={() => setPlayModalOpen(false)}
                audioUrl={menuAudioUrl}
                title={menuAudioName || "Menu Audio Preview"}
            />

            <AudioPreviewModal
                show={playModalOpen}
                onClose={() => setPlayModalOpen(false)}
                audioUrl={audioPlay}
                title={audioType}
            />

        </div>
    );
};

export default DtmfNode;
